var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('mobile-header'),_c('div',{staticClass:"main"},[_vm._t("title"),_vm._t("content")],2),_c('mobile-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }